export enum EventStatus {
  NEW = "NEW",
  COMPLETED = "COMPLETED",
  REJECTED = "REJECTED",
  IN_PROCESS = "IN_PROCESS",
}
